import React from "react";
import { QuizAnswerResponse } from "../../../../types/course";

interface QuizPreviousAnswersProps {
	previousAnswers: QuizAnswerResponse[];
	chances: number;
}

/**
 * Component to display quiz attempt history
 * Shows information about number of chances and previous attempt results
 */
const QuizPreviousAnswers: React.FC<QuizPreviousAnswersProps> = ({
	previousAnswers,
	chances,
}) => {
	return (
		<section aria-labelledby="quiz-info-heading">
			<p id="quiz-info-heading">
				Você tem <strong>{chances}</strong> chances para responder a este questionário.
				O gabarito das suas respostas será exibido ao esgotar todas as chances de responder.
			</p>

			<div role="region" aria-label="Resultados anteriores">
				<p>
					<strong>Seus Resultados Anteriores:</strong>
				</p>

				{previousAnswers.length === 0 ? (
					<p>Nenhuma tentativa realizada ainda.</p>
				) : (
					<ul style={{ listStyle: "none", padding: 0, margin: "16px 0" }}>
						{previousAnswers.map((av, index) => (
							<li key={av.id || index} style={{ marginBottom: "8px" }}>
								Tentativa {index + 1}:{" "}
								<strong>{av.qtd_acertos}</strong> acertos em{" "}
								<strong>{av.qtd_questoes}</strong> questões -{" "}
								<strong>Nota: {av.nota}%</strong>
							</li>
						))}
					</ul>
				)}
			</div>
		</section>
	);
};

export { QuizPreviousAnswers };
